import React from "react";
import { HeaderTitle, HeaderWrapper } from "./DashboardSearchHeaderStyle";
// import { useNavigate } from 'react-router-dom';

const DashboardSearchHeader = () => {
  return (
    <HeaderWrapper>
      <HeaderTitle>꽃 검색</HeaderTitle>
    </HeaderWrapper>
  );
};

export default DashboardSearchHeader;
